import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance145 = () => {
  let winners = ['27', '64'];
  return <IndividualTable matchType={"4"} gender="F" event="145" subTitle="Kungdo" data={sampleData2} topRankCount="2" winners={winners} />;
};
export default Distance145;
